module.exports = __webpack_public_path__ + "media/assets/images/landings/workforce/screens/nosco_workforce_planner-6821ad53c4d78cafa4b35cae99dec5f9.png";